"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CopyButton = exports.CopyTooltip = exports.ShareFormWrap = exports.withTooltipStyles = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const core_fusion_bs_button_with_icon_1 = require("@hotelplan/core.fusion.bs-button-with-icon");
exports.withTooltipStyles = {
    position: 'relative',
    ':hover .tooltip': {
        visibility: 'visible',
    },
};
exports.ShareFormWrap = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)({
    display: 'flex',
    mb: [2, 0],
    '.input-wrap': {
        width: '100%',
        mr: [3, '20px'],
    },
    '.input': {
        backgroundColor: 'bgLightBlue',
    },
}));
exports.CopyTooltip = styled_components_1.default.span.attrs({
    className: 'tooltip',
})(({ theme }) => theme.tooltip, {
    top: '-10px',
    left: 'auto',
    right: '0',
    transform: 'translateY(-100%)',
    '&:after': {
        left: 'auto',
        right: '5px',
        transform: 'none',
    },
});
exports.CopyButton = (0, styled_components_1.default)(core_fusion_bs_button_with_icon_1.BsButtonWithIcon).attrs({
    icon: {
        name: 'copy',
    },
    variant: 'iconBtn',
})((0, util_theme_sxc_1.sx2CssThemeFn)({
    mt: 4,
    alignSelf: 'center',
    '.icon': {
        variant: ['icons.lg', 'icons.xlg'],
    },
}), exports.withTooltipStyles);
//# sourceMappingURL=fdr-share-form.styles.js.map